import { cn } from '@/lib/css-utils'

interface RowWithSeparatorProps {
  elements: React.ReactNode[]
  classNameElements?: string
  separator?: React.ReactNode
  classNameSeparator?: string
}

export function RowWithSeparator({
  elements,
  classNameElements,
  separator = '·',
  classNameSeparator,
}: RowWithSeparatorProps) {
  if (!elements.length) {
    return null
  }

  return (
    <p className="flex items-center">
      {elements.map((item, index) => (
        <span key={index} className={classNameElements}>
          {item}
          {index < elements.length - 1 && (
            <span
              className={cn(
                'text-copy-pale font-medium px-1.5',
                classNameSeparator,
              )}
            >
              {separator}
            </span>
          )}
        </span>
      ))}
    </p>
  )
}
